import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";

export const useSortBy = <T,>(items?: T[], sortFunction?: (item: T, field: string) => string | boolean) => {
  const [sorted, setSorted] = useState<T[]>([]);
  const [sort, setSort] = useState<string>();
  const [sortDirection, setSortDirection] = useState<boolean>(false); // true = up, false = down

  const changeSortOrDirection = (sortBy: string) => {
    if (sortBy === sort) {
      setSortDirection(!sortDirection);
    } else {
      setSort(sortBy);
      setSortDirection(false);
    }
  };

  const getChevron = () => {
    return (
      <FontAwesomeIcon
        style={{ marginLeft: ".5rem", fontSize: ".75rem" }}
        icon={sortDirection ? faChevronUp : faChevronDown}
      />
    );
  };

  useEffect(() => {
    const newSorted = [...sorted];
    if (sort && newSorted) {
      if (sortDirection) {
        newSorted.reverse();
        setSorted(newSorted);
        return;
      }
      newSorted.sort((a, b) => {
        const getFieldValue = (item: T, field: string) => {
          if (sortFunction) return sortFunction(item, field);
          return (item as any)[field];
        };
        const aValue = getFieldValue(a, sort) || "";
        const bValue = getFieldValue(b, sort) || "";
        if (aValue === bValue) return 0;
        return aValue > bValue ? 1 : -1;
      });
      setSorted(newSorted);
    }
    // eslint-disable-next-line
  }, [sort, sortDirection]);

  useEffect(() => {
    if (items && Array.isArray(items)) {
      setSorted(items);
    } else if (!items) {
      setSorted([]);
    }
  }, [items]);

  return { sorted, sort, changeSortOrDirection, getChevron };
};
